import {
  Maybe,
  TagItemCard,
  TagItemType,
} from '../../graphql/generated/api-graphql'
import Router, { routes } from '../../routes/Router'
import { wediaImagesTransform } from '../Common/wedia'
import { CardVariant } from '../../components/molecules/ContentCard/styled'
import { TagVariant } from '../../components/atoms/Tag/styled'
import { ArticleCardProps } from '../../components/molecules/ArticleCard'
import { RecipeCardProps } from '../../components/molecules/RecipeCard'
import { CardContentType } from '../../components/molecules/ContentCard'
import { FolderCardProps } from '../../components/molecules/FolderCard'
import { CheeseCardProps } from '../../components/molecules/CheeseCard'
import { toScoreLetter } from '../Common/recipe'
import { Icons } from '../../components/atoms/Icon'
import { resolveArticleRoute } from '../article/resolveArticleRoute'
import { RouteDefinition } from '../../routes/definitions'

const routeByType: { [key: string]: RouteDefinition } = {
  [TagItemType.Cheese]: routes.cheese,
  [TagItemType.Recipe]: routes.recipe,
  [TagItemType.CulinaryArticle]: routes.culinaryArticle,
  [TagItemType.CulinaryFolder]: routes.folder,
  [TagItemType.Article]: routes.cultureArticle,
  [TagItemType.Plate]: routes.plate,
}

export const transformTagCard = (
  t: any,
  data?: TagItemCard | Maybe<TagItemCard>
): ArticleCardProps | RecipeCardProps | FolderCardProps | CheeseCardProps => ({
  variant: CardVariant.Tiny,
  title: data?.title,
  htmlTitleTag: 'h3',
  imageProps: {
    alt: data?.title ?? data?.thumbnail?.alt ?? '',
    maxWidth: 450,
    withHD: true,
    withLazyLoading: true,
    images: wediaImagesTransform(data?.thumbnail),
    placeholder: true,
  },
  ...(data?.slug && {
    linkProps: {
      href: Router.getRouteUrl(routeByType?.[data?.type] ?? '', {
        slug: data?.slug,
      }),
    },
  }),
  ...((data?.type === TagItemType.Article ||
    data?.type === TagItemType.CulinaryArticle) && {
    type: CardContentType.Article,
    tags: [{ label: t('tag_article'), variant: TagVariant.article }],
    ...(data?.slug && {
      linkProps: {
        href: Router.getRouteUrl(resolveArticleRoute(data), {
          slug: data?.slug,
        }),
      },
    }),
  }),
  ...(data?.type === TagItemType.CulinaryFolder && {
    type: CardContentType.Folder,
    tags: [{ label: t('tag_folder'), variant: TagVariant.folder }],
  }),
  ...(data?.type === TagItemType.Recipe && {
    type: CardContentType.Recipe,
    duration: data?.recipeCookingTime?.name ?? '',
    brandName: data?.brandName ?? '',
    score: toScoreLetter(data?.recipeNutriscore),
    ...(data?.recipePositiveFood && {
      badges: [
        {
          icon: Icons.positiveFoodBadge,
        },
      ],
    }),
  }),
  ...(data?.type === TagItemType.Cheese && {
    type: CardContentType.Cheese,
    tags: [
      ...(data?.cheeseRegion
        ? [
            {
              label: data?.cheeseRegion?.name,
              variant: TagVariant.brand,
            },
          ]
        : []),
    ],
  }),
  ...(data?.type === TagItemType.Plate && {
    type: CardContentType.Plate,
    tags: [{ label: t('tag_plate'), variant: TagVariant.planche }],
  }),
})
